<script>
import { getAllSale, listSalemen, addSalemen,calcRate } from "../../../api/crm";
import moment from "moment";
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
export default {
  data() {
    return {
      AllSaleArr: [],
      checkedSale: [],
      shuju:[],
      value2: "",
      en,
      zh,
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  async created() {
    await this.AllSale();
    await this.AllCSale();
  },
  mounted() {},
  methods: {
    translate() {
      locale.use(this[this.lang])
    },
    async AllSale() {
      const formdata = new FormData();

      const result = await getAllSale(formdata);
      if (result.code == 0) {
        this.AllSaleArr = result.data;
        this.o = {}
        this.AllSaleArr.forEach(e=>{
          this.o[e.salemanId] = {
            saleman:e.saleman,
            salemanId:e.salemanId
          }
        })
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },
    async AllCSale() {
      const formdata = new FormData();

      const result = await listSalemen(formdata);
      if (result.code == 0) {
        result.data.forEach(e => {
          this.checkedSale.push(e.salemanId);
        });
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },
    handleCheckedCitiesChange(value) {
      console.log(value);
      console.log(this.checkedSale);
    },
    async addSale() {
      const a = this.checkedSale.map(c=>this.o[c])
      const result = await addSalemen(a);
      if (result.code == 0) {
        this.$notify.success({
          title: this.$t('messages.success'),
          message: result.message
        });
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },
    async calcTheRate() {
      const formdata = new FormData();
      if (this.value2 != "" && this.value2) {
        formdata.append("reportStartTime", moment(+this.value2[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        ));
      formdata.append("reportEndTime", moment(+this.value2[1]+24*3600*1000).format(
          "YYYY-MM-DD HH:mm:ss"
        ));
      }

      const result = await calcRate(formdata);
      if (result.code == 0) {
this.shuju = result.data
        this.$notify.success({
          title: this.$t('messages.success'),
          message: result.message
        });
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    }
  }
};
</script>

<template>
  <div>
      <el-card>
    <el-button type="primary" @click="addSale">{{ $t('buttons.save') }}</el-button>
    <el-button type="primary" @click="calcTheRate">{{ $t('history.calculate') }}</el-button>

            <el-date-picker
             :key="lang"
              v-model="value2"
              type="daterange"
              unlink-panels
              range-separator="-"
              :start-placeholder="$t('common.startTime')"
              :end-placeholder="$t('common.endTime')"
              size="default"
              style="margin-left: 5px;"
            />


    <el-checkbox-group
      v-model="checkedSale"
      @change="handleCheckedCitiesChange"
    >
      <el-checkbox
        v-for="sale in AllSaleArr"
        :label="sale.salemanId"
        :key="sale.salemanId"
        >{{ sale.saleman }}</el-checkbox
      >
    </el-checkbox-group>


  </el-card>
  <el-card>
    <el-table style="width: 100%" :data="shuju">
      <el-table-column prop="salemanName" :label="$t('calcCDL.salemanName')" width="110"> </el-table-column>
      <el-table-column prop="totalJD" :label="$t('calcCDL.totalJD')" width="95"> </el-table-column>
      <el-table-column prop="totalCD" :label="$t('calcCDL.totalCD')" width="95"> </el-table-column>
      <el-table-column prop="totalRate" :label="$t('calcCDL.faRate')" width="95"> </el-table-column>
      <el-table-column :label="$t('calcCDL.oldNewRate')">
        <el-table-column prop="oldNum" :label="$t('calcCDL.oldNum')" width="60">
        </el-table-column>
        <el-table-column prop="oldCD" :label="$t('calcCDL.oldCD')" width="80">
        </el-table-column>
        <el-table-column prop="oldRate" :label="$t('calcCDL.oldRate')" width="80">
        </el-table-column>
        <el-table-column prop="newNum" :label="$t('calcCDL.newNum')" width="60">
        </el-table-column>
        <el-table-column prop="newCD" :label="$t('calcCDL.newCD')" width="80">
        </el-table-column>
        <el-table-column prop="newRate" :label="$t('calcCDL.newRate')" width="80">
        </el-table-column>
      </el-table-column>
      <el-table-column :label="$t('calcCDL.infoSourceRate')">
          <el-table-column :label="$t('calcCDL.selfInfoRate')">
            <el-table-column prop="myBD" :label="$t('calcCDL.netBD')" width="92">
          </el-table-column>
          <el-table-column prop="myCD" :label="$t('calcCDL.netCD')" width="92">
          </el-table-column>
          <el-table-column prop="myRate" :label="$t('calcCDL.faRate')" width="92">
          </el-table-column>
          </el-table-column>
          <el-table-column :label="$t('calcCDL.factoryInfoRate')">
            <el-table-column prop="faBD" :label="$t('calcCDL.faBD')" width="92">
          </el-table-column>
          <el-table-column prop="faCD" :label="$t('calcCDL.faCD')" width="92">
          </el-table-column>
          <el-table-column prop="faRate" :label="$t('calcCDL.faRate')" width="92">
          </el-table-column>
          </el-table-column>
          <el-table-column :label="$t('calcCDL.netInfoRate')">
            <el-table-column prop="netBD" :label="$t('calcCDL.netBD')" width="92">
          </el-table-column>
          <el-table-column prop="netCD" :label="$t('calcCDL.netCD')" width="92">
          </el-table-column>
          <el-table-column prop="netRate" :label="$t('calcCDL.netRate') + '%'" width="92">
          </el-table-column>
          </el-table-column>

        </el-table-column>
    </el-table>
  </el-card>
  </div>

</template>

<style scoped lang="less">
.layout-container-demo .el-main {
  padding: 0;
}

.layout-container-demo .toolbar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  right: 20px;
}

:deep(.el-icon svg) {
  color: inherit !important;
}

input.file {
  display: none;
}

.dotClass {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: block;
  margin-left: 10px;
}
/deep/ .el-table .warning-row {
  background: #f4f207;
}

/deep/ .el-table__body .success-row {
  color: black;
  background: #00ff66;
}
/deep/ .el-table__body .isorder-row {
  color: white;
  background: #5f5f5f;
}
/deep/ .el-table {
  // 每行鼠标经过得样式
  .el-table__body tr td {
    background-color: unset !important;
  }
}
</style>
